import { CommonModule, Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import {
  DocspaCoreModule,
  MarkdownModule,
  MarkdownElementsModule,
  RuntimeContentModule,
  DocsifyPluginsModule
} from '@swimlane/docspa-core';
import { WidgetsModule } from './widgets/widgets.module';

import { AppComponent } from './app.component';

import { config } from '../docspa.config';
import { environment } from '../environments/environment';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { preset } from '@swimlane/docspa-remark-preset';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    DocspaCoreModule.forRoot(config, environment),
    WidgetsModule,
    LoadingBarModule,
    LoadingBarHttpClientModule,
    LoggerModule.forRoot({ level: NgxLoggerLevel.WARN }),
    MarkdownModule.forRoot(preset),
    MarkdownElementsModule.forRoot(),
    RuntimeContentModule.forRoot({
      imports: [CommonModule, FormsModule, WidgetsModule]
    }),
    DocsifyPluginsModule,
    AppRoutingModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
